import { useMemo } from "react";
import { useSelector } from "react-redux";

export const useMapping = () => {
  const { mappings, user } = useSelector((state) => ({
    user: state.app?.user,
    mappings: state.auth?.mappings || [],
  }));
  const canGoBackToOrg = useMemo(() => {
    return mappings?.some((mapping) => mapping?.org_id === user?.current_org_id && mapping?.can_switch_to_org);
  }, [mappings, user?.current_org_id]);
  return { canGoBackToOrg };
};
